<template>
  <div id="nav" class="w-100">
    <b-navbar toggleable="lg" type="dark">
        <div class="col-md-8">
          <b-navbar-brand :href="url">
              <img width="180" alt="POPULAR" src="../assets/Popular_Logo_2020_White.png">
          </b-navbar-brand>
          <b-navbar-toggle target="nav-collapse" type="warning"></b-navbar-toggle>
        </div>
        <div class="col d-md-none">
          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
                <li class="nav-item">
                    <router-link class="nav-link" to="/careers">Careers</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" to="/csr">CSR</router-link>
                </li>
            </b-navbar-nav>
          </b-collapse>
        </div>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    msg: String
  },
  data() {
    return {
      url: process.env.VUE_APP_URL
    }
  }
}
</script>

<style>
    #nav {
        margin-bottom: 30px;
    }
    #nav .navbar {
        padding-left: 0;
        padding-right: 0;
    }
    #nav .nav-item a,
    #nav .navbar-brand {
        color: #ffffff;
        font-size: 2rem;
        font-weight: normal !important;
        padding-left: 0;
    }
    #nav a.navbar-brand:after {
        border: none !important;
    }
    #nav .nav-item a:hover::after,
    #nav .router-link-active::after{
        bottom: 1px;
    }
    #nav .nav-item a {
        margin-right: 35px;
        padding-right: 0;
    }
    #nav .router-link-active {
        /*text-decoration: underline;*/
    }
    #nav .navbar-toggler {
        position: absolute;
        right: 10px;
        top: 10px;
    }
    #nav .navbar-toggler-icon {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
    }
</style>
